import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useGetJobDescriptionQuery } from '../../services/feedbackQueries';
import Popover from '../Popover/Popover';

const classes = {
	popoverContent: {
		overflowY: 'auto',
		p: 2,
		wordBreak: 'break-all',
	},
	jdContent: {
		marginY: 1.5,
	},
};

const initialState = {
	title: '',
	locations: [{ name: '' }],
	overview: '',
	responsibilities: '',
	qualifications: '',
};

const DEFAULT_POSITION = {
	ATS: { x: 110, y: 210 },
	NON_ATS: { x: 50, y: 100 },
};

const JobDescriptionPopover = ({
	isATS,
	customerId,
	jobId,
	showJobDescPopover,
	setShowJobDescPopover,
}) => {
	const { t } = useTranslation(['job-dc']);
	const {
		data = initialState,
		isPending,
		isError,
	} = useGetJobDescriptionQuery(jobId, customerId, isATS, showJobDescPopover);

	const getContent = (key, value) => {
		if (value) {
			return (
				<Box sx={classes.jdContent}>
					<Typography variant="body1">{t(`job-description-popover.${key}`)}</Typography>
					<Typography variant="body2" dangerouslySetInnerHTML={{ __html: value }} />
				</Box>
			);
		}
		return <></>;
	};

	if (!showJobDescPopover) {
		return <div data-testid="empty-dom" />;
	}

	const getJD = () => {
		if (!isPending && !isError) {
			return (
				<>
					<Typography variant="h3">
						{data.title || t('job-description-popover.emptyTitle')}
					</Typography>
					{data?.locations?.length > 0 && data.locations[0].name && (
						<Typography variant="body1">{data.locations[0].name}</Typography>
					)}
					{getContent('overview', data.overview)}
					{getContent('responsibilities', data.responsibilities)}
					{getContent('qualifications', data.qualifications)}
					{!data.overview && !data.responsibilities && !data.qualifications && (
						<Typography variant="body1" marginY={3}>
							{t('job-description-popover.emptyDescription')}
						</Typography>
					)}
				</>
			);
		}
		return <></>;
	};
	return (
		<Popover
			type="jobDescription"
			title={t('job-description-popover.title')}
			showPopover={showJobDescPopover}
			setShowPopover={setShowJobDescPopover}
			defaultX={isATS ? DEFAULT_POSITION.ATS.x : DEFAULT_POSITION.NON_ATS.x}
			defaultY={isATS ? DEFAULT_POSITION.ATS.y : DEFAULT_POSITION.NON_ATS.y}
		>
			<Box sx={classes.popoverContent}>
				{isPending && <CircularProgress data-testid="loader" />}
				{isError && (
					<Typography variant="body1">{t('job-description-popover.errorLoading')}</Typography>
				)}
				{getJD()}
			</Box>
		</Popover>
	);
};

export default JobDescriptionPopover;
